import Configurations from './Configurations';

export default Configurations;
